export default {
    name: 'core',
    login: {
        autoCheckLogin: true,
        autoCheckPermissions: true,
    },
    authAppId: 'portal',
    logger: {
        levels: true,
    },
    pathVars: {},
    realtime: false,
    xhr: 0,
    appSettings: 'app-settings.js',
    featuresSettings: './features.json',
    appNeedsTerritory: true,
    features: {
        iconTagsEnabled: false,
    },
    links: {
        portal: '/apps/portal',
        login: '/apps/portal/login',
        'portal-edit-profile-v1': '/apps/portal/#/edit-profile',
        'portal-edit-profile-v2': 'USERPREFERENCES',
        'portal-select-customer':
            '/apps/portal?referer-app={refererAppId}&referer-url={refererAppUrl}&customer-id={customerId}/#/select-customer-v2',
        notifications: '/apps/portal/#/notifications',
        'notification-detail': '/apps/portal/#/notification/{notificationid}',
        mecApp: '/apps/portal/mecApp',
        viewCatalog: '/apps/portal/viewCatalog',
        contactUs: '/apps/portal/contactUs',
        ACCOUNTSETUP: '/apps/portal/accountSetup',
        REQUESTACCESS: '/apps/portal/requestaccess',
    },
    layout: {
        toolbar: {
            logo: 'https://americas.connect.medtronic.com/apps/login/img/medtronic-connect-logo.png',
            buttons: [],
        },
        footer: {
            logo: 'images/medtronic-connect-logo-white.png',
            links: [
                {
                    label: 'nav.privacyPolicy',
                    link: 'PRIVACYPOLICY',
                    href: (featureConfiguration) =>
                        featureConfiguration?.PrivacyTermsLink?.configuration?.privacyLink,
                    target: '_blank',
                    available: { resource: 'PrivacyPolicy', action: 'Feature' },
                },
                {
                    label: 'mdt.termsAndConditions',
                    link: 'TERMSANDCONDITIONS',
                },
            ],
        },
        sidebar: true,
    },
    api: {
        accountSetup: {
            autoOnboarding: '/api/common/users/v1/{basesiteid}/{buid}/onboarding/auto',
            getSuppliers: '/api/common/users/v1/{basesiteid}/{buid}/onboarding/suppliers',
            submitOnboarding: '/api/common/users/v1/{basesiteid}/{buid}/onboarding/manual',
        },
        profile: {
            profile: '/api/common/users/account/v1/{buid}',
        },
        contactUs: {
            sendEmail: '/api/common/users/contactUs/v1/{basesiteid}/{buid}',
            regions: '/api/global-common/account/v1/{basesiteid}/{appid}/region',
            contactusCall:
                '/api/global-common/account/v1/{basesiteid}/{buid}/{appid}/customerservicecontact',
        },
        accountfinancialInfo: {
            getaccountfinancialInfoData:
                '/api/customers/financialInfo/v1/{basesiteid}/{buid}/{appid}/{customerid}',
        },
        salesRep: {
            searchSalesRep:
                '/api/customers/salesrep/v1/{basesiteid}/{buid}/{appid}/{customerid}/search',
            searchProduct:
                '/api/catalog-common/catalog/v1/{basesiteid}/{buid}/{appid}/{customerid}/catalogResults',
        },
        createUser: {
            create: '/api/core/account/v1/{buid}/admin/createUser',
        },
        orderDiscrepancy: {
            reportDiscrepancy:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/discrepancy/report',
            reason: '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/discrepancy/v1/reasonAndResolution?territoryId={territoryId}',
            resolution:
                '/api/op/v1/{basesiteid}/{buid}/{appid}/{customerid}/orders/resolution?reasonid={reason}',
            getuserDetails: '/api/op/v1/{basesiteid}/{buid}/{appid}/profile/userAccount',
        },
        products: {
            addToCart:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cart/{wishListId}?cartType={defaultCartType}',
            getCatalogProductDetails:
                '/api/catalog-common/product/{basesiteid}/{buid}/{appid}/{customerid}/v1/{productId}',
            getCatalogProductDetailsV2:
                '/mdt-connect-product-v1/products/{productId}/customers/{customerid}',
            getStockInformation: 'data/mockdata/productMoreInformation.json',
            getOrderInformation:
                '/api/core/v1/{basesiteid}/{buid}/{appid}/{customerid}/orders/searchlines?query={productId}&imLucky=false',
            getProductPrices:
                '/api/core/admin/v1/{basesiteid}/{buid}/{appid}/{customerid}/{productId}/getProductPrices',
            getBundleProducts:
                '/mdt-estore-product-v1/api/childProducts?productNumber={productNumber}&salesOrganization={salesOrganization}&distributionChannel={distributionChannel}',
        },
        disputes: {
            fetchInvoicePDF:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/dispute/{disputeId}/resolution-form',
            getDisputeList:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/dispute/search',
            getDisputes:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/dispute/details/{disputeCaseID}',
            postRaiseDispute:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/dispute/raise',
            getDisputeReasons:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/dispute/reasons',
        },
        orders: {
            draftOrdersCount:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/drafts/count',
            delete: '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/checkout/orders/cancel',
            getInvoices:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/invoice/search/{orderId}',
            getShipments:
                '/api/estore-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orders/deliveries/search/{orderId}',
            reOrders:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/reOrder?reorderMode={reorderMode}',
            exportOrder:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orders/{orderId}/export',
            downloadCheckout:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orders/{orderId}/items/export',
            fetchPODocument:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orderdocuments/download',
            orderHistoryReport:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orderhistory/export',
            // TODO： replace with the real api when is ready
            orderMoreInfo: '/apps/cent/data/mockdata/orderMoreInfo.json',
            invoicedProducts:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orderline/search',
            downloadProductOrdered:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orderline/export',
            orderStatuscount:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orders/statuscount',
            shipments:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/shipment/search',
            transportations:
                '/api/transportation-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/search',
            exportTransportation:
                '/api/transportation-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/export',
            exportShipments:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/shipment/export',
            shipmentsCount:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/shipment/shipmentCount',
            transportationCount:
                '/api/transportation-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/transportationCount',
            returnsStatuscount:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/returnorders/statuscount',
            invoiceStatusCount:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/Invoice/statuscount',
            dateConfig:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/configuration/timeRangeConfig',
            deliveryDateDetail:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/delivery/details/{orderId}/{orderLine}?isAllCustomer={isAllCustomer}',
        },
        invoiceOverview: {
            invoiceInquiry:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/invoice/search',
            invoicePDF:
                '/api/estore-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orders/invoices/fetchPDF', // get
            emailInvoice:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/invoice/email',
            emailAllInvoice:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/invoice/emailAll?isAllCustomer={isAllCustomer}&countryCode={countryCode}&query={query}&limit={limit}&minDate={minDate}&maxDate={maxDate}',
            invoiceExport:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/invoice/export',
        },
        myorders: {
            catalogResults: '/api/core/v1/{basesiteid}/{buid}/{appid}/{customerid}/product',
            ordersSearch:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orderhistory/search',
            ordersSearchV2:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/drafts/search',
            serviceLineItem:
                '/api/core/account/v2/{basesiteid}/{buid}/login/forms/ServiceLineValidation/fieldsets?country={country}',
        },
        returns: {
            getReturnableItemsForOrder:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/returns/returnspolicies/order/{orderId}',
            validateMultipleOrderitems:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/returns/returnspolicies/orders',
            addItemToWishlist:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/wishlists/returns/{wishlistId}',
            removeItemsFromCart:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/wishlists/returns/{wishlistId}/deleteEntries',
            checkout:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/returns/checkout',
            reasons:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/returns/returnreasons?territoryId={territoryId}',
            submit: '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/returns/submit',
            cartItems:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/wishlists/returns/{cartid}',
            returnEligible:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/wishlists/returns/{wishlistId}/validateEntry',
            returnsSearch:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/returns/search',
            fetchOrderableStatus:
                '/api/dotnet-inventory/v1/{basesiteid}/{buid}/{appid}/{customerid}/consumption/orderableStatus',
        },
        templates: {
            getTemplates:
                '/api/cart-common/template/v1/{basesiteid}/{buid}/{appid}/{customerid}/templates',
            deleteTemplate:
                '/api/cart-common/template/v1/{basesiteid}/{buid}/{appid}/{customerid}/{templateId}',
            addToCart:
                '/api/cart-common/template/v1/{basesiteid}/{buid}/{appid}/{customerid}/addToCart?locale={locale}',
            addItemsToCart:
                '/api/estore-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/wishlists/{wishListId}?cartType={defaultCartType}&withPrice=false&isReturnEntries=false',
            templatesId:
                '/api/cart-common/template/v1/{basesiteid}/{buid}/{appid}/{customerid}/{templateId}',
            templateItems:
                '/api/cart-common/template/v1/{basesiteid}/{buid}/{appid}/{customerid}/{templateId}/items',
            getTemplatesForProduct:
                '/api/cart-common/template/v1/{basesiteid}/{buid}/{appid}/{customerid}/product/{productId}',
        },
        deliveryNoteRetrieval: {
            downloadPDF:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/shipment/{shipmentnumber}/fetchPDF',
            emailDeliveryNote:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/shipment/email',
            emailAllDeliveryNote:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/shipment/emailAll?isAllCustomer={isAllCustomer}&countryCode={countryCode}&query={query}&limit={limit}&minDate={minDate}&maxDate={maxDate}',
        },
        quickOrder: {
            uploadExcel:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cart/quickUpload?cartType={defaultCartType}',
            emailPrices:
                '/api/price-catalog-request/v1/createPriceRequest/{basesiteid}/{buid}/{appid}/{customerid}/UploadExcel',
            searchProduct:
                '/api/catalog-common/catalog/v1/{basesiteid}/{buid}/{appid}/{customerid}/catalogResults?limit={limit}&page={page}&query={query}&typeAHead={typeAHead}&filter={filter}&restrictbySupplierForTerritory={restrictbySupplierForTerritory}',
            addToCart: '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cart/{cartId}',
            checkPriceAndAvailability:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/pricing/checkPriceAndAvailability',
            checkPriceAndAvailabilityV2:
                '/mdt-connect-product-v1/products/prices/availability/customers/{customerid}',
            downloadTemplate: '/apps/cent/assets/Upload_Items_Template.xlsx',
            productValidation:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/product/orderableStatus?cartType={defaultCartType}',
            requestSubstitute:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cart/requestsubstitute',
            generateQuotation: '/api/price-availability/v1/{basesiteid}/{buid}/{appid}/Quotation',
        },
        catalog: {
            autocomplete:
                '/api/op/v1/{basesiteid}/{buid}/{appid}/{customerid}/product?query={query}',
            catalogList:
                '/api/catalog-common/catalog/v1/{basesiteid}/{buid}/{appid}/{customerid}/catalogResults',
            exportToExcel:
                '/api/catalog-common/catalog/v1/{basesiteid}/{buid}/{appid}/{customerid}/productResultsExcel',
            emailCatalog:
                '/api/core/catalog/v1/{basesiteid}/{buid}/{appid}/{customerid}/search/emailExport',
            recentlyPurchased:
                '/api/catalog-common/configuration/v1/mdtb2bsite/MDT/CENT/{territoryId}/recentlypurchasedoptionlist',
            emailRpcCatalog:
                '/api/price-catalog-request/v1/createPriceRequest/{basesiteid}/{buid}/{appid}/{customerid}',
        },
        wishlist: {
            cart: '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cart',
            cartItems:
                '/api/estore-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/wishlists/{cartid}',
            cartCount:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cart/{cartid}/count',
            cartGetItems:
                '/api/core/v1/{basesiteid}/{buid}/{appid}/{customerid}/wishlists/{cartid}?cartType={defaultCartType}',
            wishlistEntry:
                '/api/estore-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/{wishlistid}/entries', // patch
            deleteEntry:
                '/api/core/carts/v1/{basesiteid}/{buid}/{appid}/{customerid}/{wishlistid}/entries/{entryid}',
            deleteMultiEntry:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cart/{wishlistid}',
            saveTemplates:
                '/api/estore-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/wishlists/?type=template&cartType={defaultCartType}&locale={locale}',
            addToTemplate:
                '/api/cart-common/template/v1/{basesiteid}/{buid}/{appid}/{customerid}/addToCart?locale={locale}',
            uploadExcel:
                '/api/estore-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/wishlists/{wishlistId}/upload',
            updateCartPriceAndAvailability:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/pricing/{wishListId}',
            requestSubstitute:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cart/requestsubstitute?cartId={cartid}&cartType={defaultCartType}',
            downloadBillReplaceTemplate: '/apps/cent/assets/BR_Excel.xlsx',
            downloadBillReplaceTemplateIndia: '/apps/cent/assets/BR_Excel_India.xlsx',
        },
        transaction: {
            splitOrder: '/apps/cent/data/mockdata/checkoutsample.json',
            productSearch:
                '/api/catalog-common/catalog/v1/{basesiteid}/{buid}/{appid}/{customerid}/catalogResults?limit={limit}&page={page}&query={query}&typeAHead={typeAHead}&filter={filter}&restrictbySupplierForTerritory={restrictbySupplierForTerritory}',
            barcodeSearch:
                '/api/catalog-common/catalog/v1/{basesiteid}/{buid}/{appid}/{customerid}/searchbybarcode?query={query}',
            productValidate:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/product/orderableStatus?cartType={cartType}',
            addCart:
                '/api/estore-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/wishlists/{wishListIdTransaction}?cartType={cartType}&withPrice=false',
            updateCarts:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cart/{wishListIdTransaction}',
            checkPriceAndAvailability:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/pricing/checkPriceAndAvailability',
            autocomplete:
                '/api/op/v1/{basesiteid}/{buid}/{appid}/{customerid}/prod uct?query={query}&filter={filter}',
            getTransactionTypes:
                '/api/connect-cms/v1/cms/forms/TransactionTypes/fieldsets?country={country}',
            userAccount: '/api/core/profile/v2/{basesiteid}/{buid}/{appid}/userAccount',
            deleteFromCart:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cart/{wishListIdTransaction}',
            searchPartners: '/api/customers/admin/searchPartners/{basesiteid}/{buid}/{appid}',
            updatePatientInfo:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/{wishListIdTransaction}/patientInfo',
            uploadExcel:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cart/{cartId}/upload?cartType={orderType}',
        },

        checkout: {
            addToCart:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cart/{wishListId}?cartType={cartType}',
            checkoutOptions:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/checkout/{orderId}/options',
            notes: '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/checkout/{orderId}/notes',
            shippingmethod: '/apps/cent/data/mockdata/shipments.json',
            carrier: '/apps/cent/data/mockdata/carriers.json',
            updateOrderHeader:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/checkout/{orderId}', // PATCH
            validateaddress:
                '/api/global-common/account/v1/{basesiteid}/{buid}/portal/ValidateAddress',
            updateCheckoutItem:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/checkout/{orderId}/entries',
            deleteCheckoutItem:
                '/api/estore-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orders/{orderId}/deleteOrderEntries',
            approveOrder:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/checkout/{orderId}/approve',
            submitOrder: '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/checkout', // post
            shippingPref: '/api/op/v1/{basesiteid}/{buid}/{appid}/profile/{customerid}',
            profilePrefrence: '/api/core/v2/{basesiteid}/{buid}/{appid}/profile/userAccount',
            updateOrderPriceAndAvailability:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/pricing/updateOrderPriceAndAvailability/{orderId}',
            deleteOrderEntry:
                '/api/cart-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/checkout/{orderId}/entries/delete',
            getCheckoutSoldto: '/api/customers/admin/SearchCustomers/{basesiteid}/{buid}/{appid}',
            getCheckoutNotesConfig: '/api/connect-cms/v1/cms/forms/CheckoutNotes/fieldsets',
            partnerSearch:
                '/api/customers/partner/v1/{basesiteid}/{buid}/{appid}/{customerid}/search',
        },

        creditCard: {
            getCreditCard:
                '/api/common/users/creditCards/v1/{basesiteid}/{buid}/{appid}/creditCards',
            addnewCreditcard: '/api/creditcards/management/v1/{basesiteid}/{buid}/{appid}',
            updateCreditCard: '/api/creditcards/management/v1/{basesiteid}/{buid}/{appid}/{cardId}',
            deleteCreditCard: '/api/creditcards/management/v1/{basesiteid}/{buid}/{appid}/{cardId}',
            getCreditAccessToken: '/api/creditcards/tokens/v1/{basesiteid}/{buid}/{appid}/token',
            preAuthcall: '/api/creditcards/authorization/v1/{basesiteid}/{buid}/{appid}',
            savenewcc: '/api/op/v1/{basesiteid}/{buid}/{appid}/profile/addCreditCardDetail',
            configuration:
                '/api/creditcards/management/v1/{basesiteid}/{buid}/{appid}/configuration',
            getResponsePacket:
                '/api/creditcards/tokens/v1/{basesiteid}/{buid}/{appid}/responsepacket',
            threeDSAccessToken: '/api/creditcards/tokens/v1/{basesiteid}/{buid}/{appid}/3dstoken',
        },
        inventory: {
            searchProducts:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/products/search',
            searchInstances:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/instances/search',
            inventoryReport:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/export',
            lastCycleCount:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/lastCycleCount',
            foundProducts:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/foundProducts',
            stockStatusCheck:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/stockStatusCheck',
            manageMissing:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/missingProducts',
            manageFoundOrderType: '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/ordertypes',
            convertFound:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/convertFounds',
            destockSubmit:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/destock/{sessionId}',
            manageMissingDestock:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/destock/manageMissing',
            deleteFound:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/instances/deleteFound',
            updateUBD:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/{instanceId}/updateUbd',
            activeSessions:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/activeSessions?findMode=CycleCount',
            stockroom:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/stockrooms',
            partnerSearch: '/api/core/partners/v2/partnerSearch?query={query}&filter={filter}',
            checkinOptions:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/specialCheckIn/options',
            destockOptions:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/destockOptions',
        },
        nis: {
            checkinTemplate:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/{checkInType}/template',
            specialCheckInSubmit:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerId}/specialCheckIn/{specialCheckInId}/submit',
            inventoryCheckin:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/checkin/{sessionId}',
            productByBarcode:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/scan/{sessionId}',
            sessionId:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/scan/start',
            cancel: '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cancel/{sessionId}',
            rejectSessionId:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/reject/{sessionId}',
            export: '/api/core/inventory/v1/{basesiteid}/{buid}/{appid}/{customerid}/{stockeventid}/export',
            manualProduct:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/manualProduct',
            addMissingInfo:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/scan/{sessionId}',
            checkoutProducts:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/checkoutProducts',
            roomsStructure:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockroomId}/roomsStructure',
            removeline:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/removeline/{sessionId}/{productInstanceId}',
            cycleCount: {
                reviewAndConfirm:
                    '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/review/{sessionId}', // get
                submitCycleCount:
                    '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/cyclecount/{sessionId}',
                uploadExcel:
                    '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockRoomId}/cycleCount/uploadExcel?sessionId={sessionId}', // POST
                review: '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockRoomId}/review/{sessionId}', // get
                downloadExcelError:
                    '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockRoomId}/cycleCount/downloadExcelError', // POST
                template:
                    '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{stockRoomId}/cycleCount/template',
            },
            specialCheckInStart:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerId}/specialCheckIn/start',
            specialCheckInSession:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerId}/specialCheckIn/{specialCheckInId}/addProductByBarcode',
            specialCheckInEntries:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerId}/specialCheckIn/{specialCheckInId}/entries',
            specialCheckInManageFoundSubmit:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/convertFounds',
        },
        configurations: {
            addressFormats: '/api/configuration/addressformats/v1/{basesiteid}/{buid}?app={appid}',
        },
        customer: {
            v1: {
                searchCustomers: '/api/customers/customer/v1/{basesiteid}/{buid}/{appid}/search',
                endReceivers: '/api/customers/customer/v1/{basesiteid}/{buid}/{appid}/{customerid}/endReceivers',
            },
        },
        home: {
            titles: '/apps/cent/data/mockdata/insights.json',
        },
        supportPage: {
            getSupportData: '/apps/cent/data/mockdata/supportData.json',
        },
        priceVariance: {
            reportPriceVariance:
                '/api/op/v1/{basesiteid}/{buid}/{appid}/{customerid}/product/reportPriceVariation',
        },
        poPending: {
            orders: '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/pendingPO/v1/search',
            savePO: '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orders/orderpo',
            exportToExcel:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/pendingPO/v1/export',
            poValidation:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orders/validatePO',
        },
        reportPriceVariance: {
            rpv: '/api/catalog-common/product/{basesiteid}/{buid}/{appid}/{customerid}/v1/pricevariance',
        },
        rma: {
            installbase: {
                search: '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/rma/equipment/search',
                export: '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/rma/equipment/export',
            },
            request: {
                submitrrma:
                    '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/rma',
                fieldsets: '/api/connect-cms/v1/cms/forms/{field}/fieldsets',
            },
            rmaHistory: {
                viewRMAList:
                    '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/rma/history/search',
                exportToExcel:
                    '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/rma/history/export',
            },
            rmaDetails: {
                getRmaDetails:
                    '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/rma/{rmaId}',
                exportExcel:
                    '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/rma/{rmaId}/export',
            },
            partnerDetail:
                '/api/customers/customer/v1/{basesiteid}/{buid}/{appid}/{customerid}/supplierContract',
        },
        login: {
            config: '/api/openid/.well-known/openid-configuration',
            token: '/api/openid/connect/token',
            revocation: '/api/openid/connect/revocation',
            userinfo: '/api/common/users/userinfo',
            endsession: '/api/openid/connect/endsession',
            userPermissions:
                '/api/customers/customer/v1/{basesiteid}/{buid}/{appid}/default?customerId={customerid}',
            resourceRightsForCustomer:
                '/api/security/resourcerights/{basesiteid}/{buid}/{appid}/{customerid}',
            resourceRights: '/api/security/resourcerights/{basesiteid}/{buid}',
            defaultCustomer: '/api/customers/customer/v1/{basesiteid}/{buid}/{appid}/default',
            defaultContract:
                '/api/customers/customer/v1/{basesiteid}/{buid}/{appid}/{customerid}/defaultContract',
        },
        notifications: {
            search: '/api/notifications/webNotifications/{buid}/{appid}/search',
            count: '/api/notifications/webNotifications/{buid}/{appid}/count',
            deleteNotifications: '/api/notifications/webNotifications/{buid}/{appid}',
            getNotification: '/api/notifications/webNotifications/{buid}/{appid}/{messageId}',
            markAsRead: '/api/notifications/webNotifications/{buid}/{appid}/{messageId}/markasread',
            markAsReadBulk: '/api/notifications/webNotifications/{buid}/{appid}/markasread',
            channel:
                '/api/notifications/webnotificationsettings/{buid}/{appid}/{notificationType}/channel/{channel}',
            userSettings: '/api/notifications/webnotificationsettings/{buid}/{appid}/{email}',
            channelsForType:
                '/api/notifications/webnotificationsettings/{buid}/{appid}/{userId}/{type}',
            // notificationPreferences: '/api/configuration/appconfig/v1/paramsNoAuth?basesite={basesiteid}&bu={bu}&app={appid}&target=SupplierConfig&targetAttribute=CommunicationHub&fields=DEFAULT&onlyActive=true&isCacheAble=true',
            // notificationPreferencesList: '/api/configuration/appconfig/v1/paramsNoAuth?basesite={basesiteid}&bu={buid}&app={appid}&target=SupplierListConfig&targetAttribute=CommunicationHub&fields=DEFAULT&onlyActive=true&isCacheAble=true',
            // NOTE: Quick fix for china DNS, should be using the API on top, but leave it like this for now as a quick fix for UAT 20220718:Alevale
            notificationPreferences:
                '/api/core/configuration/v1/{basesiteid}/{bu}/{appid}/parameterized',
            notificationPreferencesList: '/api/configuration/appconfig/v1/params',
            notificationsEnabled:
                '/api/common/users/notification/v1/{basesiteid}/{buid}/{appid}/{userId}',
        },
        account: {
            getCustomerDetails: '/api/op/v1/{basesiteid}/{buid}/{appid}/profile/{customer}',
            getUser: '/api/core/account/v2/{buid}',
        },
        l18n: {
            translations:
                '/api/core/localization/v1/{basesiteid}/{buid}/{appid}/translations?lang={lang}&fallBack={fallBack}',
        },
        common: {
            addressValidation:
                '/api/global-common/account/v1/{basesiteid}/{buid}/{appid}/validateAddress',
            mediaEntries: '/api/connect-media/v1/data/mediaEntries/{documentID}/file',
            getPackingInformation:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/returns/packing/{packingType}?supplier={supplierInfo}&locale={locale}',
            countries: '/api/global-common/wellknown/v1/{basesiteid}/countries',
            culture: '/api/global-common/wellknown/v1/{basesiteid}/culture',
            submitNewRequest:
                '/api/customers/account/v1/{basesiteid}/{buid}/{appid}/RequestNewShipTo?CountryISOCode={countryISO}',
            submitModifyRequest:
                '/api/customers/account/v1/{basesiteid}/{buid}/{appid}/RequestModifyShipTo?CountryISOCode={countryISO}',
            stockrooms:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/stockrooms',
            updateStockroom:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/ssp/{sspId}?disconnectPartnerRole={disconnectPartnerRole}',
            addStockroom:
                '/api/inventory-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/ssp?disconnectPartnerRole={disconnectPartnerRole}',
            getShipTos:
                '/api/core/account/v2/{basesiteid}/{buid}/{appid}/{customerid}/ShipToAddressList?disableInventory={disableInventory}',
            getSoldTos: '/api/customers/partner/v1/{basesiteid}/{buid}/{appid}/{partnerId}',
            uploadFile: '/mdt-com-filemanagement-v1/file/upload?fileType=PO',
            getUploadedFile: '/mdt-com-filemanagement-v1/file/{fileId}',
            deleteUploadedFile: '/mdt-com-filemanagement-v1/file/{fileId}',
            documentRequest: '/api/global-common/document/v1/{basesiteid}/{buid}/{appid}/{type}',
            getRegistrationDetails:
                '/api/common/users/requestAccess/v1/{basesiteid}/{buid}/registrationDetails',
            orderDetails:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orders/{orderId}',
            user: '/api/common/users/v1/{basesiteid}/{buid}/{appid}/{userId}/user',
        },
        forms: {
            downloadHide: '/api/connect-cms/v1/cms/forms/downloadHide/fieldsets?country=DF',
            featuresConfigured: '/api/configuration/features/v2/{basesiteid}/{buid}/features',
        },
        cmsForms: {
            fieldsets:
                '/api/configuration/cms/v1/{basesiteid}/{buid}/forms/{fieldsetsId}/fieldsets?country={country}',
        },
        warranty: {
            warrantyClaimDetails:
                '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/claims/{claimId}',
            validateWarrantyClaim:
                '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/product/search/{serialNumber}?type={type}',
            facility: '/api/customers/customerdetails/v1/{basesiteid}/{buid}/{appid}/facilities',
            warrantyClaimSubmit:
                '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/claims',
            reportingPreferences:
                '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/claims/reportingPreferences/{emailAddress}',
            warrantyReportingPreference:
                '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/claims/reportingPreferences',
            search: '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/claims/search',
            sendAnInquiry: '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/inquiry',
            claimStatusList:
                '/api/connect-cms/v1/cms/forms/claimsStatusList/fieldsets?country={country}',
            downloadCreditMemo:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/invoice/{invoiceNumber}/fetchPDF',
            signature:
                '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/claims/{claimId}',
            downloadClaimForm:
                '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/claims/attachment/{id}',
            downloadExcelClaim:
                '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/claims/{claimId}/download',
            downloadClaims:
                '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/claims/download',
            uploadAttachment:
                '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/claims/attachment',
            uploadAttachmentFolderId:
                '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/claims/attachment?folderId={folderId}',
            deleteAttachment:
                '/mdt-commercial-warrantyclaim-v1/api/v1/{appid}/{customerid}/claims/attachment/{attachmentId}',
        },
        itc: {
            accountStatement:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/accounting/search',
            accountStatementRequestedDate:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/accounting/search?requestedDate={requestedDate}',
            accountingCount:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/accounting/statuscount',
            accountingCountRequestedDate:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/accounting/statuscount?requestedDate={requestedDate}',
            exportFormat:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/accounting/export/{exportFormat}',
            emailExportFormat:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/accounting/email/{exportFormat}',
            paymentUsage:
                '/api/order-common/v1/mdtb2bsite/MDT/{appid}/{customerid}/accounting/payment-data/{paymentNumber}',
            accountInvoiceDetail:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/accounting/details/{documentNumber}?isAllCustomer={isAllCustomer}',
            orderDocuments:
                '/api/order-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/orderdocuments/download',
        },
        salesOut: {
            distributorId:
                '/api/channelconnect/v1/distributors/search/findByHybrisId?hybrisId={hybrisId}',
            submissions:
                '/api/channelconnect/v1/distributors/{distributorId}/submissions?sort=dueDate,desc',
            download: '/api/customers/partner/v1/{basesiteid}/{buid}/{appid}/{customerid}/download',
            regionCountryMapping:
                '/api/channelconnect/v1/distributors/{distributorId}/regionCountryMapping',
            submissionDetail: '/api/channelconnect/v1/submissions/{submissionId}',
            salesOutSearch: '/api/channelconnect/v1/salesOutEntries/search/findBySubmissionId',
            inventorySearch: '/api/channelconnect/v1/inventoryEntries/search/findBySubmissionId',
            analyzeSubmission: '/api/channelconnect/v1/submissions/{submissionId}/analyze',
            submitSubmission: '/api/channelconnect/v1/submissions/{submissionId}/submit',
            noSales: '/api/channelconnect/v1/submissions/{submissionId}',
            catalogDownload:
                '/api/channelconnect/v1/distributors/{distributorId}/products?baseSiteId={basesiteid}&buId={buid}&appId={appid}&customerId={customerid}',
            countries: '/api/channelconnect/v1/submissions/dataload/countries/user/{userEmailId}',
            savePermanentId: '/api/customers/partner/v1/{basesiteid}/{buid}/{appid}/replacepartner',
            salesOutDeleteEntry: '/api/channelconnect/v1/salesOutEntries/{id}',
            salesOutDownload:
                '/api/channelconnect/v1/submissions/{submissionId}/salesOutEntries/download',
            salesOutbulkDelete: '/api/channelconnect/v1/submissions/{submissionId}/salesOutEntries',
            searchProduct:
                '/api/catalog-common/catalog/v1/{basesiteid}/{buid}/{appid}/{customerid}/catalogResults?limit={limit}&page={page}&imlucky=true&optimize=false&query={query}&productExclusionForSalesOut={productExclusionForSalesOut}',
            submitSalesRecord: '/api/channelconnect/v1/salesOutEntries',
            productSummary:
                '/api/channelconnect/v1/submissions/reporting/accuracy/distributor/{distributorId}/period/{date}',
            periods:
                '/api/channelconnect/v1/submissions/reporting/accuracy/distributor/{distributorId}/periods',
            submissionAccuracyDownload:
                '/api/channelconnect/v1/submissions/reporting/accuracy/distributor/{distributorId}/period/{date}/download',
            editSalesRecord: '/api/channelconnect/v1/salesOutEntries/{id}',
            inventoryDeleteEntry: '/api/channelconnect/v1/inventoryEntries/{id}',
            inventoryDownload:
                '/api/channelconnect/v1/submissions/{submissionId}/inventoryEntries/download',
            inventorybulkDelete:
                '/api/channelconnect/v1/submissions/{submissionId}/inventoryEntries',
            inventorySubmissionErrors:
                '/api/channelconnect/v1/inventoryEntries/search/findByHasErrors?submissionId={submissionId}',
            analyseJob: '/api/channelconnect/v1/jobs/{jobId}',
            findByError:
                '/api/channelconnect/v1/salesOutEntries/search/findByHasErrors?submissionId={submissionId}',
            findyByDuplicate:
                '/api/channelconnect/v1/salesOutEntries/search/findByHasDuplicates?submissionId={submissionId}',
            downloadSalesOutExcelTemplate: '/api/v3/{basesiteid}/documents',
            downloadInventoryDoc:
                '/api/v3/mdtb2bsite/documents?applications={appId}&documentCategory={CHANNEL_INVENTORY_TEMPLATES}&region={countryIsocode}',
            uploadSalesoutExcel:
                '/api/channelconnect/v1/submissions/{submissionId}/salesOutEntries/upload',
            uploadInventoryExcel:
                '/api/channelconnect/v1/submissions/{submissionId}/inventoryEntries/upload',
            submitInventory: '/api/channelconnect/v1/inventoryEntries',
            editInventory: '/api/channelconnect/v1/inventoryEntries/{id}',
            addEndCustomer: '/api/customers/partner/v1/{basesiteid}/{buid}/{appid}/{customerid}',
            statusReportFilterOptions:
                '/api/channelconnect/v1/submissions/dataload/countries/user/{userEmailId}',
            statusReportUpdatedFilterOptions:
                '/api/channelconnect/v1/submissions/dataload/countries/user/{userEmailId}?country={selectedCountry}&region={selectedRegion}&superRegion={selectedSuperRegion}',
            statusReportPeriodOptions:
                '/api/channelconnect/v1/submissions/reporting/dashboard/periods?country={selectedCountry}&region={selectedRegion}&superRegion={selectedSuperRegion}',
            statusReportDashboard:
                '/api/channelconnect/v1/submissions/reporting/dashboard?userId={userEmailId}&country={selectedCountry}&superRegion={selectedSuperRegion}&region={selectedRegion}&period={selectedPeriod}',
            statusReportGrid:
                '/api/channelconnect/v1/submissions/reporting/dashboard/grid?userId={userEmailId}&country={selectedCountry}&period={selectedPeriod}&superRegion={selectedSuperRegion}&region={selectedRegion}&filter={filter}',
            submissionDownload:
                '/api/channelconnect/v1/submissions/reporting/dashboard/grid/download',
            manualApprove: '/api/channelconnect/v1/submissions/{submissionId}/manualapprove',
        },
        serviceRequest: {
            overview:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/search',
            statusOverview:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/overview',
            details:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/details/{caseNumber}?isAllCustomer={isAllCustomer}',
            serviceOverviewExport:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/export',
            reviewPendingRequest:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/email/approvependingrequest',
            returnPendingDevice:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/email/devicependingreturn',
        },
        equipmentOveview: {
            searchAndList:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/equipment/search',
            statusOverview:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/equipment/overview',
            details:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/equipment/details/{serialNumber}/{materialNumber}?isAllCustomer={isAllCustomer}',
            serviceHistory:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/search',
            equipmentExport:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/equipment/export',
            contractExpiringSoonEmail:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/email/contractexpiringsoon',
            warrantyRecentlyExpiredEmail:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/email/warrantyrecentlyexpired',
            warrantyExpiringSoonEmail:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/email/warrantyexpiringsoon',
            addEquipment:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/email/equipmentdetails',
        },
        newServiceRequest: {
            serviceRequested:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/servicenow/servicereasons',
            submitNewServiceRequest:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/servicenow/submitcase',
            getLocation:
                '/api/servicerequest-common/v1/{basesiteid}/{buid}/{appid}/{customerid}/servicenow/getlocation',
            fileUpload: '/dms-upload',
            deleteUploadedFile: '/dms-delete',
            downloadUploadedFile: '/dms-download',
            updateFileMetadata: '/dms-put',
        },
        acm: {
            endReceiver: '/api/loyalty/acm/{basesiteid}/{buid}/{appid}/{customerid}/overviewDetails?endreceiver={endreceiverId}',
            endReceiverOverview: '/api/loyalty/acm/{basesiteid}/{buid}/{appid}/{customerid}/overviewDetails',
            checkout: '/api/loyalty/acm/{basesiteid}/{buid}/{appid}/{customerid}/checkout',
            endReceiverCheckout: '/api/loyalty/acm/{basesiteid}/{buid}/{appid}/{customerid}/checkout?endreceiver={endreceiverId}',
        },
    },
    accountPreferencesTabIds: {
        ACCOUNT: 'account',
        SHIPPING: 'shipping',
        CREDITCARD: 'creditCard',
        NOTIFICATION: 'notification',
        NOTIFICATIONID2: 'notification.id2',
        RDTPREFERENCE: 'rdtPreference',
    },
    timeZone: {
        GA: 'CET',
    },
    decimalDigits: 2,
    themes: [
        { id: 'theme-electric', name: 'electric' },
        { id: 'theme-default', name: 'default' },
    ],
};
